import { render } from "./DataTableControl.vue?vue&type=template&id=2d23d432&scoped=true"
import script from "./DataTableControl.vue?vue&type=script&lang=js"
export * from "./DataTableControl.vue?vue&type=script&lang=js"

import "./DataTableControl.vue?vue&type=style&index=0&id=2d23d432&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23d432"]])

export default __exports__